// extracted by mini-css-extract-plugin
export default {"container":"InviteInfo_container__VB6IG","footer":"InviteInfo_footer__RK9S6","button":"InviteInfo_button__xy9It"};